var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.a,.c{stroke:#fa1616;stroke-width:1.5px;}.a{stroke-dasharray:2;}.c{stroke-linecap:round;stroke-linejoin:round;}.d{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 24,
    cy: 24,
    r: 23.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-892 -252)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 24,
    height: 24,
    transform: "translate(904 264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M157.411,157.411,144,144m13.411,0L144,157.411",
    transform: "translate(765.294 125.294)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailedIcon);
export default __webpack_public_path__ + "static/media/payment-failed-icon.d075851eb5199081ffcbe036afbf7e5c.svg";
export { ForwardRef as ReactComponent };